<template>
	<div class="all">
		<AppTable
			primaryKey="id"
			:columns="columns"
			:rows="tableData"
			class="all-table"
			:isProgressBar="isProgressBarLoading"
			@lazyload="onLazyload"
			@sort="onSort"
			@search="onFilter"
		>
			<template
				v-for="(col,x) of modifieredCols"
				v-slot:[col]="scopeData"
			>
                <AdminCell
                    :key="x"
                    :cellValue="scopeData.row[col]"
                    :cellInfo="{rowId: scopeData.row.id, propName: col}"
                    :selected="[]"
                    :changeOptions="getChangeOptions(col)"
                    @choose="onChoose"
                    @change="onCellEdit($event, col, scopeData.row.id)"
                />
<!--				<BaseCell-->
<!--					:key="x"-->
<!--					:content="scopeData.row[col]"-->
<!--				/>-->
			</template>

            <template v-slot:entity_info="scopeData">
                <BaseButton
                    :view="'secondary'"
                    @click="getEntityInfo(scopeData)"
                >Инфо</BaseButton>
            </template>

			<template v-slot:image_src="scopeData">
				<AppPhoto
					:small="scopeData.row.photo.small"
					:big="scopeData.row.photo.big"
				/>
			</template>

			<template v-slot:light="scopeData">
				<AppLight :isLight="scopeData.row.light == 1" />
			</template>

			<template v-slot:country_id="scopeData">
				<CountryFlag :abbreviation="scopeData.row.country_id" />
			</template>

			<template v-slot:oohdesk_id="scopeData">
				<AppIdentifier :firstId="scopeData.row.ooh_marker_id" :secondId="scopeData.row.oohdesk_id" />
			</template>

			<template v-slot:image_link="scopeData">
				<AppLink
                    v-if="!isEditImageLink(scopeData.row.id)"
                    :link="scopeData.row.image_link"
                />
                <AdminCell
                    v-if="isEditImageLink(scopeData.row.id)"
                    :isContentAlwaysEditable="true"
                    :options="[]"
                    :selected="[]"
                    :cellValue="scopeData.row['image_src']"
                    :cellInfo="{rowId: scopeData.row.id, propName: 'image_src'}"
                    @choose="onChoose"
                    @change="onCellEdit($event, 'image_src', scopeData.row.id)"
                />
                <BaseButton
                     v-if="!(isEditImageLink(scopeData.row.id))"
                    :view="'simple'"
                    @click="editImageLink(scopeData.row.id)"
                ><IconEdit/></BaseButton>
			</template>

            <template v-slot:direction="scopeData">
                <MapDirection :item="scopeData.row" :isEditable="false" />
            </template>
			<template v-slot:image_map="scopeData">
				<MapImage :lng="scopeData.row.lng" :lat="scopeData.row.lat" />
			</template>

            <template v-slot:materials="scopeData">
                <div style="display: block">
                    <div
                        v-for="(value,index) of scopeData.row.materials"
                        :key="index"
                    >
                        {{value}}
                    </div>
                </div>
            </template>
		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/components/Table2/Table"
import AppPhoto from '@/components/CellComponents/Photo.vue'
import CountryFlag from '@/components/CellComponents/CountryFlag.vue'
import AppLight from '@/components/CellComponents/Light.vue'
import AppIdentifier from '@/components/CellComponents/Identifier.vue'
import AppLink from '@/components/CellComponents/Link.vue'
// import BaseCell from '@/components/CellComponents/BaseCell.vue'
import MapImage from '@/components/CellComponents/MapImage.vue'
import MapDirection from '@/components/CellComponents/MapDirection.vue'
import BaseButton from "@/components/Base/BaseButton";
import AdminCell from "@/components/CellComponents/AdminCell2";
import IconEdit from "@/components/Icons/IconEdit.vue";
export default {
	name: "AllTab",
	components: {
		AppTable,
		AppPhoto,
		CountryFlag,
		AppLight,
		AppIdentifier,
		AppLink,
		// BaseCell,
		MapImage,
        BaseButton,
        MapDirection,
        AdminCell,
        IconEdit
	},
    data: () => ({
        editImageLinkRow: null
    }),
	props: {
		columns: {
			type: Array,
			required: true
		},
		tableData: {
			type: Array,
			required: true
		},
		isProgressBarLoading: {
			type: Boolean,
			default: false
		},
		modifieredCols: {
			type: Array,
			requried: true
		}
	},
	created() {
		this.$emit('load', {
            urlName: 'withoutPhotoList'
			// url: 'https://catalog.oohdesk.ru/catalog/list'
		})
	},
	methods: {
		/**
		 * @param {Object} $event - название колонки по которой был произведен клик в шапке таблицы
		 */
		onSort($event) {
			this.$emit('sort', $event)
		},
		/**
		 * @param {Object} $event - объект содержащий значения для фильрации
		 */
		onFilter($event) {
			this.$emit('filter', $event)
		},
		onLazyload() {
			this.$emit('lazyload')
		},
        getEntityInfo(scopeData){
            this.$emit('entityInfo', scopeData.row.id);
        },

        editImageLink(rowId){
            this.editImageLinkRow = rowId;
        },
        /**
         * @param {Object} - объект содержащий измененное значение и id
         * @param {rowId}
         * @param {colName}
         */
        onCellEdit($event, colName, rowId) {
            console.log('$event', $event);
            this.editImageLinkRow = null;
            this.$emit('editCell', {
                attributeName: colName,
                rowId: rowId,
                optionContent: $event.content,
                optionId: $event.id,
            })
        },

        isEditImageLink(rowId){
            return this.editImageLinkRow === rowId
        },

        /**
         * записывает изменения в store
         * не отправляет на backend
         * @param {Object} $event
         */
        onChoose($event) {
            this.$emit('edit', $event)
        },
        /**
         * @returns {Array} - список опций которые для ручного редактирования двойным кликом
         */
        getChangeOptions(colName) {
            const colData = this.columns.find(col => col.prop === colName)
            return colData.changeOptions
        },
	},
}
</script>

<style lang="scss" scoped>
// .all {}
</style>
